<template>
    <div>
        <VueDateFilter default-filter="today" @dateFilterChange="filter" />
        <div  v-if="!loading" style="padding: 25px;">
            <LineChart :labels="labels" :datasets="datasets" />
        </div>
        <div v-else class="loader" id="loader-1"></div>
    </div>
</template>

<script>

import VueDateFilter from "../../generic/VueDateFilter";
import LineChart from "../../admin/charts/LineChart";
const DATE_FORMAT = 'DD/MM/YYYY HH:mm';

export default {
    name: "VisitGraphWidget",
    components: {LineChart, VueDateFilter},
    data() {
        return {
            labels: [],
            datasets: {},
            loading: false
        }
    },
    methods: {

        filter(dateFromTimestamp, dateToTimestamp, type) {
            const start = this.parseTime(dateFromTimestamp * 1000);
            const end = this.parseTime(dateToTimestamp * 1000);
            this.loading = true;
            axios.post('api/insights/graph', {
                start_at: start,
                end_at: end,
                type: type
            }).then((res) => {
                this.loading = false;
                this.datasets = res.data.datasets;
                this.labels = res.data.labels
            }).catch(({response, request}) => {
                if(response.data && response.data.errors) {
                    for (const property in response.data.errors) {
                    }
                }
                this.loading = false;
            })
        },
        parseTime(time) {
            return time && moment(time).format(DATE_FORMAT);
        },
    }
}
</script>

<style scoped>
.loader{
    width: 100px;
    height: 100px;
    border-radius: 100%;
    position: relative;
    margin: 0 auto;
}

#loader-1:before, #loader-1:after{
    content: "";
    position: absolute;
    top: -10px;
    left: -10px;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    border: 10px solid transparent;
    border-top-color: #3498db;
}

#loader-1:before{
    z-index: 100;
    animation: spin 1s infinite;
}

#loader-1:after{
    border: 10px solid #ccc;
}


@keyframes spin{
    0%{
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100%{
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/widgets/VisitGraphWidget/VisitGraphWidget.vue